import React, { useState, useRef, useEffect } from "react";
import Select from "react-select";

function MultipleSelectDropdown({
  options,
  isSearchable,
  onChange,
  value,
  onScrollToBottom,
  onScroll,
  isMulti = false,
  ...other
}) {
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const selectRef = useRef(null);

  // Only handle outside click when isMulti is true
  useEffect(() => {
    if (!isMulti) return;
    function handleClickOutside(event) {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setMenuIsOpen(false);
      }
    }
    if (menuIsOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuIsOpen, isMulti]);

  // Only open menu on click when isMulti is true
  const handleInputClick = () => {
    if (isMulti) setMenuIsOpen(true);
  };

  // Only keep menu open after select when isMulti is true
  const handleChange = (selected, e) => {
    onChange && onChange(selected, e);
    if (isMulti) {
      // keep open
    } else {
      // let react-select handle closing
    }
  };

  return (
    <div
      className="multiple-select"
      ref={selectRef}
      onClick={handleInputClick}
      style={{ cursor: "pointer" }}
    >
      <Select
        isMulti={isMulti}
        options={options}
        isSearchable={isSearchable}
        onChange={handleChange}
        value={value}
        onMenuScrollToBottom={onScroll}
        menuIsOpen={isMulti ? menuIsOpen : undefined}
        {...other}
      />
    </div>
  );
}

export default MultipleSelectDropdown;
